import React from 'react';
import { Redirect } from 'react-router-dom';

import { useQuery } from '@apollo/client/react';
import { Box, Loader, Text } from '@opendoor/bricks/core';
import ContentCard from '@opendoor/bricks/deprecated/UNSAFE_layout/ContentCard';

import { BUYER_APPOINTMENTS, IBuyerAppointments } from '../graphql/queries/BuyerAppointments';
import { BuyerAppointmentCard } from './BuyerAppointmentCard';
import { ContentWrapper } from './ContentWrapper';
import LadyAtDeskIcon from './icons/LadyAtDeskIcon';

const BuyerAppointmentsSection: React.FC = () => {
  const { data, loading, error } = useQuery<IBuyerAppointments>(BUYER_APPOINTMENTS);

  let content: JSX.Element | null = null;

  if (error) {
    return <Redirect to="/error" />;
  }

  if (loading) {
    content = <Loader />;
  }

  if (data) {
    if (data.buyerAppointments.length === 0) {
      content = (
        <Box width="100%" textAlign="center">
          <LadyAtDeskIcon />
          <Text my={4}>No active buyer appointments.</Text>
          <Text>
            Customers who schedule a tour for a home in your community will show up here. Please
            reach out to your Homebuilder Partner Manager if you have any questions.
          </Text>
        </Box>
      );
    } else {
      content = (
        <>
          {data.buyerAppointments.map((buyerAppointment, i) => (
            <BuyerAppointmentCard key={i} buyerAppointment={buyerAppointment} />
          ))}
        </>
      );
    }
  }

  return (
    <ContentWrapper>
      <ContentCard title="Buyer Appointments">
        <Text fontSize="s00" mb={3}>
          Track your new home tour requests generated from Opendoor here.
        </Text>
        {data?.buyerAppointments && (
          <Text mb={4} fontWeight="bold">
            <>
              {data.buyerAppointments.length}
              {data.buyerAppointments.length === 1 ? ' result' : ' results'}
            </>
          </Text>
        )}
        {content}
      </ContentCard>
    </ContentWrapper>
  );
};

export default BuyerAppointmentsSection;
